import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import React from "react";

const DataQualityTab: React.FC = () => {
  return (
    <Box>
      <Typography level="body-md">
        Data quality details and metrics will be displayed here.
      </Typography>
    </Box>
  );
};

export default DataQualityTab;
